import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v6m0 3v1.5m0 3v.5","key":"svg-0"}],["path",{"d":"M18 11l-6 -6","key":"svg-1"}],["path",{"d":"M6 11l6 -6","key":"svg-2"}]]

/**
 * IconArrowUpDashed
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtZGFzaGVkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiA1djZtMCAzdjEuNW0wIDN2LjUiIC8+CiAgPHBhdGggZD0iTTE4IDExbC02IC02IiAvPgogIDxwYXRoIGQ9Ik02IDExbDYgLTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/arrow-up-dashed
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpDashed = createReactComponent('outline', 'arrow-up-dashed', 'ArrowUpDashed', __iconNode);

export default IconArrowUpDashed;